import { checkedBg, checkedBorder, classNames, focusOutline, indeterminateBg, indeterminateBorder } from "../../Resources/CSS/styling";

export default function Checkbox({ checked, onChange, className, id, label }) {
    return (
        <div className="flex h-6 shrink-0 items-center">
            <div className="group grid size-4 grid-cols-1">
                <input
                    id={id}
                    name={id}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className={classNames(`col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white ${checkedBorder} ${checkedBg} ${indeterminateBorder} ${indeterminateBg} ${focusOutline} disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto`)}
                />
                <svg
                    fill="none"
                    viewBox="0 0 14 14"
                    className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                >
                    <path
                        d="M3 8L6 11L11 3.5"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="opacity-0 group-has-[:checked]:opacity-100"
                    />
                    <path
                        d="M3 7H11"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="opacity-0 group-has-[:indeterminate]:opacity-100"
                    />
                </svg>
            </div>
            {label && <label htmlFor={id} className="block text-sm/6 text-gray-900 font-medium ml-2">
                {label}
            </label>}
        </div>
    )
}